import { Navigate, Outlet } from 'react-router-dom';
import Product from '../pages/ExampleProducts/Detail';
import Home from '../pages/Home';
import Promotions from '../pages/Promotions';
import Search from '../pages/Search';
import ShopNearMe from '../pages/Shops/NearMe';
import ProductDetail from '../pages/Shops/ProductDetail';
import MyProfile from '../pages/buyer/MyProfile';
import MyAddress from '../pages/buyer/MyAddress';
import SCGFamily from '../pages/buyer/SCGFamily';
import MyBankAccount from '../pages/buyer/MyBankAccount';
import AddShop from '../pages/buyer/MyShop/AddShop';
import AddShop1 from '../pages/buyer/MyShop/AddShop1';
import Login from '../pages/Login';
import LoginOTP from '../pages/Login/LoginOTP';
import Register from '../pages/Register';
import Shops from '../pages/Shops';
import LineLogin from '../pages/Login/LineLogin';
import Cart from '../pages/Carts';
import ConfirmPayment from '../pages/Carts/ConfirmPayment';
import Health from '../pages/Health';
import MyOrders from '../pages/MyOrders';
import CartConfirm from '../pages/Carts/ShoppingConfirm';
import OrderSummary from '../pages/Carts/OrderSummary';
import NewOrderSummary from '../pages/Carts/OrderSummary/OrderSummary';
import ProductCategories from '../pages/ProductCategories';
import ProductCategoriesDetail from '../pages/ProductCategories/Detail';
import TermsOfUse from '../pages/pdpa/TermsOfUse';
import PrivacyNotice from '../pages/pdpa/PrivacyNotice';
import CookiesNotice from '../pages/pdpa/CookiesNotice';
import DataSubjectRequests from '../pages/pdpa/Notice';
import MaintenanceMode from '../pages/MaintenanceMode';
import Promotion from '../pages/Promotion';
import ServiceFilters from '../pages/Services';
import ServiceListings from '../pages/Services/Listing';
import ServiceJob from '../pages/Services/Job';
import ServiceContact from '../pages/Services/Contact';
import ServiceApplyJob from '../pages/Services/ApplyJob';
import OrderServiceDetail from '../pages/MyOrderServices/OrderServiceDetail';
import LayoutTechnician from '../layouts/Technician';
import LayoutProfile from '../layouts/Profile';
import ServiceSelectAddress from '../pages/Services/selectAddress';
import PartnerHome from '../pages/Partners/Home';
import PageNotFound from '../pages/404';

const routes = (isLoggedIn: boolean) => [
  // !------enable maintenance mode--------
  // { path: "*", element: <Navigate to="/maintenance-mode" />},
  // {
  //   path: '/maintenance-mode',
  //   element: <MaintenanceMode />,
  // },
  // !------------------------------------
  {
    path: 'app',
    element: isLoggedIn ? <Outlet /> : <Navigate to='/login' />,
    children: [
      { path: '', element: <>index page</> },
      { path: 'test', element: <>test page</> },
      { path: 'dashboard', element: <>dashboard22</> },
    ],
  },
  {
    path: 'profile/*',
    element: <LayoutProfile />,
    children: [{ path: 'my-order', element: <MyOrders /> }],
  },
  {
    path: 'my-shop',
    element: <Outlet />,
    children: [
      { path: '', element: <AddShop /> },
      { path: 'add-my-shop', element: <AddShop1 /> },
    ],
  },
  {
    path: '/login',
    element: <Outlet />,
    children: [
      { path: '', element: <LoginOTP /> },
      { path: 'login-default', element: <Login /> },
    ],
  },
  {
    path: '/login-default',
    element: <Login />,
  },
  {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/home/promotion/:id',
    element: <Promotion />,
  },
  {
    path: '/promotions',
    element: <Promotions />,
  },
  {
    path: '/search',
    element: <Search />,
  },
  {
    path: '/TermsOfUse',
    element: <TermsOfUse />,
  },
  {
    path: '/PrivacyNotice',
    element: <PrivacyNotice />,
  },
  {
    path: '/CookiesNotice',
    element: <CookiesNotice />,
  },
  {
    path: '/DataSubjectRequests',
    element: <DataSubjectRequests />,
  },
  {
    path: '/health',
    element: <Health />,
  },
  {
    path: '/product-categories',
    element: <Outlet />,
    children: [
      { path: '', element: <ProductCategories /> },
      { path: 'detail', element: <ProductCategoriesDetail /> },
    ],
  },
  {
    path: '/cart',
    element: <Outlet />,
    children: [
      { path: '', element: <Cart /> },
      { path: 'order-summary', element: <NewOrderSummary /> },
      { path: 'confirm-order-summary', element: <OrderSummary /> },
      { path: 'confirm-payment', element: <ConfirmPayment /> },
      { path: 'confirm-cart', element: <CartConfirm /> },
    ],
  },
  {
    path: 'my-shops',
    element: <Outlet />,
    children: [{ path: '', element: <AddShop /> }],
  },
  {
    path: 'shops',
    element: <Outlet />,
    children: [
      { path: '', element: <Shops /> },
      { path: 'near-me', element: <ShopNearMe /> },
      { path: 'product-detail', element: <ProductDetail /> },
    ],
  },
  {
    path: 'services',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <ServiceFilters />,
      },
      {
        path: 'address',
        element: <ServiceSelectAddress />,
      },
      {
        path: 'jobs',
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <ServiceListings />,
          },
          {
            path: ':id',
            element: <ServiceJob />,
          },
        ],
      },
      {
        path: 'contact',
        element: <Outlet />,
        children: [
          {
            path: ':id',
            element: <ServiceContact />,
          },
        ],
      },
    ],
  },
  {
    path: 'apply-job',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <ServiceApplyJob />,
      },
    ],
  },
  { path: 'examples/products/:id', element: <Product /> },
  {
    path: 'my-jobs',
    element: <OrderServiceDetail id='JOBS2212062656' />,
  },
  {
    path: 'my-technician/*',
    element: <LayoutTechnician />,
  },
  {
    path: 'partner/:id/*',
    element: <PartnerHome />,
  },
  { path: '*', element: <PageNotFound /> },
];

export default routes;
